import styled from 'styled-components'
import { myPalette } from '~/shared/ui/theme/myPalette'

export const LoginStepTitle = styled.div`
  color: ${myPalette.mutedText.main};
  font-size: 16px;
  margin: 9px 0 37px;
  text-align: center;
`

export const RegistrationWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
`

export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px 16px;
`

export const GridItem = styled.div`
  grid-column: 1;
`
